/* unplugin-vue-components disabled */import { render } from "./Footer.vue?vue&type=template&id=009c7b1b&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=009c7b1b&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户哈尔滨医科大学-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009c7b1b"]])

export default __exports__